import { HttpClient } from "../common/http-client";
import { Environment } from "../environment/app-settings";
import { ConsentFetchModel } from "../models/settings/consent.fetch.model";
import { ILenConfigState } from '../store/types'

//#region SettingService Instance
let instance: SettingService
//#endregion

//#region Interfaces
export interface ILenConfigFetchModel {
  data: ILenConfigState;
}
//#endregion

export class SettingService {
    private readonly _client: HttpClient;
    private readonly _consentUrlPath = "/settings/consent";
    private readonly _lenConfigUrlPath = "/settings/globalConfig";
  
    constructor() {
        if (instance) { //SINGLETON DESIGN PATTERN
           throw new Error("New instance cannot be created!!");
        }
     
        instance = this;
        this._client = new HttpClient(Environment.apiUrl);
    }

    public async getConsents(): Promise<ConsentFetchModel>{
      return (await this._client.get<ConsentFetchModel>(this._consentUrlPath)).data;
    }

    public async getLenConfig() : Promise<ILenConfigFetchModel>{
      return (await this._client.get<ILenConfigFetchModel>(this._lenConfigUrlPath)).data;
    }
}

let settingsService = Object.freeze(new SettingService())//SINGLETON DESIGN PATTERN
export default settingsService;